import { lazy } from 'react';
import { roles } from 'common/constants/options';
import DefaultLayout from 'components/layout/DefaultLayout';
import routes from 'common/routes';

const ExerciseList = lazy(() => import('components/exercise/ExerciseList'));
const PlayExerciseList = lazy(() => import('components/exercise/PlayExerciseList'));
const ExerciseRequestList = lazy(() => import('components/exercise/ExerciseRequestList'));

const exerciseRoutes = [
  {
    key: 'exercises',
    exact: true,
    path: routes.exercises.path,
    component: ExerciseList,
    layout: DefaultLayout,
    allowedRoles: [roles.administrator, roles.trainer]
  },
  {
    key: 'exercises-play',
    exact: true,
    path: routes.exercisesPlay.path,
    component: PlayExerciseList,
    layout: DefaultLayout,
    allowedRoles: [roles.administrator]
  },
  {
    key: 'exercise-requests',
    exact: true,
    path: routes.exerciseRequests.path,
    component: ExerciseRequestList,
    layout: DefaultLayout,
    allowedRoles: [roles.administrator, roles.trainer]
  }
];

export default exerciseRoutes;
